/**
 * 产品规格默认值
 *
 * 来源：现有桌面计算程序提示「常用导程是 5, 10, 20」+ NMS 编码段 5 减速比常见取值
 * 这些默认在共享库内固化，使本库可独立运行；
 * ERP 内嵌时由 ERP 注入实际可选集合（来自 pcfg_characteristic_value 表）。
 */
/** 默认丝杆导程候选 (mm) */
export const DEFAULT_LEADS = [5, 10, 20];
/** 默认减速机比候选 */
export const DEFAULT_REDUCERS = [1, 3, 5, 7, 10, 15, 20, 25, 30, 40, 50];
/** 默认同步轮减速比候选 */
export const DEFAULT_SYNC_DEC_RATIOS = [1, 1.2, 1.5, 2, 3];
/** 默认同步轮增速比候选（默认不增速） */
export const DEFAULT_SYNC_INC_RATIOS = [1];
/** 默认机械效率 */
export const DEFAULT_EFFICIENCY = 0.85;
/**
 * 默认重力加速度
 *
 * 取 10 与现有桌面计算程序保持一致；
 * 如需精确换算 N→KG 应改为 9.80665（误差约 1.97%）。
 */
export const DEFAULT_GRAVITY = 10;
/** 默认负载余量（推力安全系数） */
export const DEFAULT_LOAD_SAFETY_FACTOR = 1.2;
/** 默认速度余量（默认不要求额外速度裕度） */
export const DEFAULT_SPEED_SAFETY_FACTOR = 1.0;
/** 默认返回方案数 */
export const DEFAULT_TOP_N = 5;
/**
 * 默认评分权重
 * - power 0.30：功率冗余越少越好（直接体现电机价格压力）
 * - thrust 0.15：推力贴合误差
 * - speed  0.15：速度贴合误差
 * - ratio  0.10：传动复杂度（直驱 < 减速机 < 同步轮 < 减速机+同步轮）
 * - price  0.30：综合成本（电机+减速机+同步轮）
 */
export const DEFAULT_SCORE_WEIGHTS = {
    power: 0.3,
    thrust: 0.15,
    speed: 0.15,
    ratio: 0.1,
    price: 0.3,
};
/**
 * 默认价格配置（⚠️ 占位值，待销售/采购提供真实报价后校准）
 *
 * 单位：人民币元。
 * - 电机价以 motor-library.ts 中 price 字段为准；自定义/未填字段时按 motorPricePerWatt 兜底。
 * - 减速机/同步轮按经验数量级填入（与电机价处于相同数量级，确保对评分有可见影响）。
 *
 * 来源：
 *   - 电机：1688 / 阿里巴巴 / 工控商城公开报价的中位估算（国产中端通用伺服）
 *   - 减速机：保留用户给的 1:2:4 比例（5/10/20），按行星减速机市场价整体放大到元
 *   - 同步轮：单组同步带+轮经验价 ~200 元
 */
export const DEFAULT_PRICE_CONFIG = {
    /** 电机兜底估值：每 W 约 2 元（自定义电机未填 price 时使用；中等功率单瓦约 1.7~2.5 元） */
    motorPricePerWatt: 2.0,
    /** 减速机分档：直驱免费，i ≤ 3 计 500，i ≤ 10 计 1000，i > 10 计 2000 */
    reducerPriceBands: [
        { maxRatio: 1, price: 0 },
        { maxRatio: 3, price: 500 },
        { maxRatio: 10, price: 1000 },
        { maxRatio: 100, price: 2000 },
    ],
    /** 同步轮（含同步带）：dec ≠ 1 或 inc ≠ 1 附加 200 */
    syncPulleyPrice: 200,
    /** 归一化基准：典型 2KW 直驱方案 ~3800，2KW + 同步轮 ~4000 → priceFactor ~ 1 */
    referencePrice: 4000,
};
//# sourceMappingURL=product-spec.js.map